import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Select from 'react-select';
import ErrorBoundary from '../../../shared/error-boundary';
import {
  Button,
  Container,
  FormField,
  Label,
  Row,
  SuccessMessage,
  selectorProps,
} from '../common/form';
import commonProps from '../common/common-props';
import linkFunds from '../../../services/lwadmin/profile/profile-funds-service';
import Header from './common/header';

export default function ProfileFundsAdmin({ profile }) {
  const {
    id,
    funds,
    availableFunds,
  } = profile;

  const emptyFund = { label: 'None (eg. not link to any fund)', value: null };
  const firstFund = funds.length > 0 ? { label: funds[0].name, value: funds[0].id } : emptyFund;

  const [fund, setFund] = React.useState(firstFund);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

  const mappedFunds = availableFunds.length > 0 ? [
    emptyFund,
    ...availableFunds.map(f => ({ label: f.name, value: f.id })),
  ] : [];

  const handleFundChange = selectedFund => {
    setFund(selectedFund);
    setShowSuccessMessage(false);
  };

  const submit = e => {
    e && e.preventDefault();

    linkFunds(id, [fund.value]).then(() => {
      setShowSuccessMessage(true);
    });
  };

  return (
    <ThemeProvider theme={commonProps()}>
      <ErrorBoundary>
        <Header type="funds" profile={profile} />
        <Container>
          {showSuccessMessage && (
            <SuccessMessage>
              Fund successfully linked to this profile
            </SuccessMessage>
          )}
          <Row>
            <Label htmlFor="company">Fund</Label>
            <FormField>
              <Select
                {...selectorProps}
                className="fund"
                value={fund}
                options={mappedFunds}
                placeholder="Select fund"
                onChange={handleFundChange}
              />
            </FormField>
          </Row>
          <Button className="btn btn-primary" onClick={submit}>Save</Button>
        </Container>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

ProfileFundsAdmin.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
    position: PropTypes.string,
    organization: PropTypes.string,
    funds: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
    availableFunds: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
  }).isRequired,
};
